import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import VuexPersistence from "vuex-persist";

import Cookies from "js-cookie";

import customer from "@/store/_customer";
import layout from "@/store/_layout";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "uOEOCRFfVy";

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    customer: state.customer,
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize,
      businessType: state.layout.businessType
    }
  })
});

const sessionStorage = new VuexPersistence({
  key: storageKey,
  storage: window.sessionStorage
  // reducer: state => ({
  //   customer: state.customer
  // })
});

const cookieStorage = new VuexPersistence({
  key: storageKey,
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) =>
    Cookies.set(key, state, {
      expires: 3
    }),
  reducer: state => ({
    customer: {
      customerId: state.customer.customerId,
      sessionToken: state.customer.sessionToken
    }
  })
});

const store = new Vuex.Store({
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage:
      "https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg",
    drawer: null
  },
  modules: {
    customer,
    layout
  },
  getters: {
    lasturl: state => {
      return state.customer.lasturl;
    },
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    customerId: state => {
      return state.customer.customerId;
    },
    customerName: state => {
      return state.customer.customerName;
    },
    customerLevel: state => {
      return state.customer.customerLevel;
    },
    customerEmail: state => {
      return state.customer.customerEmail;
    },
    sessionToken: state => {
      return state.customer.sessionToken;
    },
    cart: state => {
      return state.customer.cart;
    },
    dinein: state => {
      return state.customer.dinein;
    },
    displayTitle: state => {
      return state.layout.displayTitle;
    },
    isLoggedIn: state => {
      if (
        state.customer.sessionToken != "" &&
        state.customer.customerId != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    isMinimized: state => {
      return state.layout.sidebar.minimized;
    },
    businessType: state => {
      return state.layout.businessType ? state.layout.businessType.type_id : "";
    },
    businessName: state => {
      return state.layout.businessType
        ? state.layout.businessType.type_name
        : "";
    },
    latitude: state => {
      return state.customer.latitude;
    },
    longitude: state => {
      return state.customer.longitude;
    },
    address: state => {
      return state.customer.customerAddress;
    },
    merchantConstraints: state => {
      return state.customer.merchantConstraints;
    },
    displayType: state => {
      return state.customer.displayType;
    }
  },
  plugins: [
    localStorage.plugin
    // sessionStorage.plugin
  ],
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    }
  },
  actions: {}
});

export default store;
